import { fetchPost, fetchGet, rootApi, fetchPostFile, fetchGetText } from '../helpers/api';

const stationApi = `${rootApi}/stations`;

// export const create = station => fetchPost(stationApi, station);

export const create = station => fetchPostFile(stationApi, station);

export const update = station => fetchPostFile(`${stationApi}/update`, station);

export const archive = stationId => fetchGet(`${stationApi}/${stationId}/archive`);

export const restore = stationId => fetchGet(`${stationApi}/${stationId}/restore`);

export const search = criteria => fetchPost(`${stationApi}/search`, criteria);

export const fetchSample = () => fetchGet(stationApi);

export const stationTime = stationId => fetchGet(`${stationApi}/stationTime/${stationId}`)

export const getStationFields = stationId => fetchGetText(`${stationApi}/findStationFields/${stationId}`)